export const name = "ARRAY_LENGTH";
export const summary = `Gets the number of elements in an array.`;
export const reference = `
## ARRAY_LENGTH

Gets the number of elements in an array.

\`\`\`
ARRAY_LENGTH(array_expression)
\`\`\`

### Description

Returns the size of the array. Returns 0 for an empty array. Returns \`NULL\` if the \`array_expression\` is \`NULL\`.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT
  ARRAY_LENGTH(["coffee", NULL, "milk"]) AS size_a,
  ARRAY_LENGTH(["cake", "pie"]) AS size_b;

/*--------+--------*
 | size_a | size_b |
 +--------+--------+
 | 3 | 2 |
 *--------+--------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/array_functions
`;
